export default __webpack_public_path__ + "static/media/SecondImageModel.7fdd18a8.png";